import type { Workspace } from "./queries";

export type EventTab = {
  path: string;
  label: string;
  slice: string;
  built: boolean;
  purpose: string;
  /** The number shown beside the tab, from the workspace counts. */
  count?: (w: Workspace) => number;
};

/** The workspace tabs. `built` tabs render a real screen; the rest show what is coming, with the
 * same counts, so the strip's links never land on a blank page. */
export const EVENT_TABS: EventTab[] = [
  {
    path: "brief",
    label: "Brief",
    slice: "U2d",
    built: true,
    purpose: "What the host wants, what is still missing and where each value came from.",
    count: (w) => w.counts.open_impacts,
  },
  {
    path: "conversation",
    label: "Conversation",
    slice: "U3b",
    built: true,
    purpose: "The thread with the host, and the composer to reply as the concierge.",
  },
  {
    path: "vendors",
    label: "Vendors",
    slice: "U4",
    built: true,
    purpose: "The shortlist for each category, RFQs and quotes.",
    count: (w) => w.counts.open_rfqs,
  },
  {
    path: "package",
    label: "Package",
    slice: "U4",
    built: true,
    purpose: "Build, check and publish the package, then deliver it to the host.",
    count: (w) => w.counts.unconfirmed_vendors,
  },
  {
    path: "money",
    label: "Money",
    slice: "U6",
    built: true,
    purpose: "Payment, payouts, refunds and any problem reported on this event.",
  },
  {
    path: "activity",
    label: "Activity",
    slice: "U2d",
    built: true,
    purpose: "Everything that happened on this event, and every stage change.",
  },
];
